import Component from '@glimmer/component';
import { type ActionVariant, linkStyles } from '../-private/action-styles.ts';
import { default as IconComponent } from '../-private/components/link-or-button-icon.gts';
import type { Signature as IconSignature } from '../-private/components/link-or-button-icon';

export interface Signature {
  Element: HTMLAnchorElement;
  Args: {
    /**
     * The look of the link (default: `link`). The same names as WrButton and
     * WrLinkTo: `primary`, `primary-white-border`, `outlined`,
     * `outlined-mini`, `link`, `inverted-link`.
     */
    variant?: ActionVariant;
    icon?: IconSignature['Args']['icon'];
  };
  Blocks: {
    default: [];
  };
}

export default class WrAnchorComponent extends Component<Signature> {
  get styles() {
    return linkStyles(this.args.variant ?? 'link');
  }

  <template>
    {{! href is expected to be provided by the caller through ...attributes }}
    {{! eslint-disable ember/template-link-href-attributes }}
    <a class={{this.styles}} ...attributes>
      <IconComponent @icon={{@icon}} />
      {{yield}}
    </a>
  </template>
}
